import { EDeprecatedCategoryType } from '@/services/doctor/DiagnosisCategoryService';
import { EDiagnosisContactType } from './diagnosis';
import { EIntegratedSearchTabType } from './search';

export enum DoctornowWebViewType {
  SafeAreaView = 'SafeAreaView',
  BottomSafeAreaView = 'BottomSafeAreaView',
  KeyboardAvoidingView = 'KeyboardAvoidingView',
}

export interface EmergencyContraceptiveScreenProps {
  categoryId: number;
  type: EDeprecatedCategoryType;
}

export interface QnaDetailScreenProps {
  questionPid: string;
  result_section?: EIntegratedSearchTabType;
}

export interface HospitalSearchScreenProps {
  latitude?: string;
  longitude?: string;
  keyword?: string;
  sortType?: string;
  mode?: string;
}

export interface FaceToFaceDiagnosisMapBySemaglutideScreenProps {
  latitude: number;
  longitude: number;
  treatmentId: string;
  treatmentMedicineId: string;
  dispensationUnit?: number;
  treatmentMedicineStrengthId?: string;
  medicineUnitId?: number;
}

export interface FaceToFaceDiagnosisMapByLiraglutideScreenProps {
  latitude: number;
  longitude: number;
  treatmentId: string;
  treatmentMedicineId: string;
  dispensationUnit?: number;
  treatmentMedicineStrengthId?: string;
  medicineUnitId?: number;
}

export interface FaceToFaceDiagnosisMapByOralDietMedicineScreenProps {
  categoryId: string;
  type: string;
  treatmentMedicineId: string;
  treatmentMedicineUnitId: number;
}

export interface FaceToFaceDiagnosisMapByOtherScreenProps {
  categoryId: number;
  type: string;
}

export interface MagazineTagListScreenProps {
  tagName: string;
}

export interface HospitalDetailScreenProps {
  hospitalPid: string;
}

export interface MagazineDetailScreenProps {
  magazinePid: string;
}

export interface jumpToHomeScreenWithHomeTabProps {
  isNonFaceToFaceTreatmentRequestClick?: boolean;
}

export interface treatmentRequestAppScreenProps {
  categoryId?: string | string[];
  type: string;
  doctorInfo: {
    id: number;
  };
  userTargetId: number;
  contactType: EDiagnosisContactType;
  pharmacyId?: string;
  treatmentMedicineUnitId?: string | string[];
  dispensationUnit: number;
  treatmentMedicineStrengthId?: string | string[];
  treatmentMedicineId?: string | string[];
}

export interface FamilyRegisterWebViewScreenProps {
  userId?: string;
}

export interface MedicineDictionaryDetailScreenProps {
  medicineDictionaryPid: string;
  keyword: string;
}

export interface MagazineAuthorDetailScreenProps {
  authorPublicId: string;
}
